var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holder",class:{ labeled: _vm.label }},[(_vm.label)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"switch",class:{ active: _vm.innerValue, border: _vm.border },on:{"click":_vm.toggle}},[_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }